"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MigrationTarget = void 0;
const utils_1 = require("../../utils");
const lodash_1 = require("lodash");
var MigrationTarget;
(function (MigrationTarget) {
    function isUpdateNeeded(updated, old, excludedPaths) {
        const changed = (0, utils_1.isModified)(updated, old, excludedPaths);
        // no point in updating
        if (old && !changed) {
            return 'unchanged';
        }
        // got changes but target has already been updated
        if (old && (0, lodash_1.gt)(old.modifiedAt, old.migratedAt)) {
            return 'conflict';
        }
        return 'changes';
    }
    MigrationTarget.isUpdateNeeded = isUpdateNeeded;
})(MigrationTarget || (exports.MigrationTarget = MigrationTarget = {}));
//# sourceMappingURL=MigrationTarget.js.map